import axios from "axios";
import { IBookingLocation } from "../../types";
import qs from "qs";

export interface IGetBookingLocationsReturn {
    locations: IBookingLocation[]
}

export const getBookingLocations = async (req: { tenants: string[], dealers: string[] }): Promise<IGetBookingLocationsReturn> => {
    const response = await axios.get('/booking/search/locations', { params:{
        tenants: req.tenants.join(","),
        dealers: req.dealers.join(",")
    } });
    return response.data;
};